import queryString from 'query-string'
import { camelizeKeys } from 'humps'

function parseQuery(search) {
  if (!search) return {}

  return camelizeKeys(queryString.parse(search))
}

export default parseQuery
